import { createContext, useContext } from "react";

export const PayeeStoreContext = createContext({
  payeeId: "",
  payeeLoaded: false,
  payeeCatalogId: "",
  catalogLoaded: false,
  cartId: ""
});

export const usePayeeStore = () => useContext(PayeeStoreContext);